import { render, staticRenderFns } from "./PartnerClassesForm.vue?vue&type=template&id=e93977e2&scoped=true"
import script from "./PartnerClassesForm.vue?vue&type=script&lang=js"
export * from "./PartnerClassesForm.vue?vue&type=script&lang=js"
import style0 from "./PartnerClassesForm.vue?vue&type=style&index=0&id=e93977e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93977e2",
  null
  
)

export default component.exports